import React from 'react';
import { TableSimple, type TableProps } from '@/components/TableSimple';
import { ManagedTable, type TableViewOptions } from '@/components/ManagedTable';
import { useAuth } from '@/context/AuthContext';

export type TableType = 'simple' | 'basic';
export type { TableAction, TableColumn, TableProps } from '@/components/TableSimple';

export function Table<T extends object = Record<string, unknown>>(
    props: TableProps<T> & TableViewOptions & { type?: TableType }
): React.ReactElement {
    const { type = 'simple', ...tableProps } = props;
    const { isRoot, isIt } = useAuth();
    const resolvedTableProps = {
        ...tableProps,
        exportable: Boolean(tableProps.exportable || isRoot || isIt),
    };

    if(props.viewKey){ return <ManagedTable<T> {...resolvedTableProps} viewKey={props.viewKey} />; }

    switch(type){
        case 'simple':
        case 'basic':
        default:
            return <TableSimple<T> {...resolvedTableProps} />;
    }
}

export default Table;
